var repeatZeroes = function (_a) {
    var times = _a.times;
    var result = '';
    for (var i = 0; i < times; i += 1) {
        result += '0';
    }
    return result;
};
var removeOccurrences = function (_a) {
    var from = _a.from, toRemove = _a.toRemove;
    var escapedStr = toRemove.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
    var re = new RegExp(escapedStr, 'g');
    return from.replace(re, '');
};
export var valueIsEmpty = function (_a) {
    var val = _a.val, allowEmpty = _a.allowEmpty;
    return allowEmpty && (val === '' || val === null || val === undefined);
};
export var getRawValue = function (_a) {
    var displayedValue = _a.displayedValue, delimiter = _a.delimiter, separator = _a.separator, allowEmpty = _a.allowEmpty;
    var result = displayedValue;
    result = removeOccurrences({ from: result, toRemove: delimiter });
    result = removeOccurrences({ from: result, toRemove: separator });
    if (valueIsEmpty({ val: result, allowEmpty: allowEmpty })) {
        return null;
    }
    return parseInt(result, 10);
};
export var formattedRawValue = function (_a) {
    var val = _a.val, integer = _a.integer, allowEmpty = _a.allowEmpty, delimiter = _a.delimiter, separator = _a.separator, precision = _a.precision;
    var finalPrecision = integer ? 0 : precision;
    var finalSeparator = integer ? '' : separator;
    if (valueIsEmpty({ val: val, allowEmpty: allowEmpty })) {
        return '';
    }
    if (val === null) {
        return '';
    }
    var displayValue = val;
    if (integer) {
        displayValue = val / 100;
    }
    var minChars = '0'.length + finalPrecision;
    var result = '';
    result = "".concat(displayValue);
    if (result.length < minChars) {
        var leftZeroesToAdd = minChars - result.length;
        result = "".concat(repeatZeroes({ times: leftZeroesToAdd })).concat(result);
    }
    var beforeSeparator = result.slice(0, result.length - finalPrecision);
    var afterSeparator = result.slice(result.length - finalPrecision);
    if (beforeSeparator.length > 3) {
        var chars = beforeSeparator.split('').reverse();
        var withDots = '';
        for (var i = chars.length - 1; i >= 0; i -= 1) {
            var char = chars[i];
            var dot = i % 3 === 0 ? delimiter : '';
            withDots = "".concat(withDots).concat(char).concat(dot);
        }
        withDots = withDots.substring(0, withDots.length - 1);
        beforeSeparator = withDots;
    }
    result = finalPrecision > 0 ? beforeSeparator + finalSeparator + afterSeparator : beforeSeparator;
    return result;
};
